var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{staticClass:"!gl-items-center !gl-pl-2",attrs:{"variant":"muted","aria-label":_vm.name}},[_c('div',{staticClass:"gl-truncate"},[_c('gl-icon',{staticClass:"gl-mb-[-1px] gl-mr-1",style:(_vm.colorStyle),attrs:{"size":12,"name":_vm.iconName}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }